/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React from "react"
import TopHeader from "../../components/TopHeader"
import { useSelector, useDispatch } from "react-redux"
import { useEffect, useCallback, useContext, useState } from "react"
import { useLocation, useSearchParams } from "react-router-dom"
import Debounce from "../../CommonMethods/Debounce"
import { limitReducer, resetArrays } from "../../redux/MultiselectRowsConditionally"
import ManageDeviceTable from "./Components/Table"
import ManageDeviceTopBar from "./Components/Topbar"
import Pagination from "../../components/Pagination"
import Limit from "../../components/Limit"
import moment from "moment"
import GlobalContext from "../../components/Context/GloablContext"
import CustomOverLay from "../../components/CustomOverLay"
import { handleIsAPICall } from "../../redux/commonSlice"
import {useGetDeviceListQuery,useDeleteDeviceMutation,useExportDevicesMutation, useDeviceStatusChangeMutation} from "../../features/deviceSlice"
import SearchEmptyScreen from "../../components/SearchEmptyScreen"
import Emptyscreen from "../../components/EmptyScreen"
import ConfirmationPrompt from "../../components/ConfirmationPrompt"
import AnimatedModel from "../../components/Animation/AnimatedModel"
import { handleAddFilterValues } from "../../redux/systemConfigSlice"
import DeviceAdvanceSearch from "../../components/Layout/AdvancedSearch/DeviceSearch"
import { convertDatesToEpochUTC } from "../../CommonMethods/ConvertFilterDatetoEpochUtcFormat"
import { setDeviceSearch, resetDeviceSearch,setSearchApplied } from '../../redux/deviceSearchSlice';

export default function ManageDevice({isPatient,patient_id,setIsAnyFieldFilled}) {
    const { setToastmessage, Toastmessage, toastErrorMessage, setToastErrorMessage, isSideBar,isAdvancedSearchOpen,setIsAdvancedSearchOpen } = useContext(GlobalContext);
    const [suggestions, setSuggestions] = useState("")
    const [exportDevice] = useExportDevicesMutation()
    const [statusChange] = useDeviceStatusChangeMutation()
    const [limit, setLimit] = useState("15")
    const [deleteDevice] = useDeleteDeviceMutation()
    const [skip, setSkip] = useState(true)
    const [selectedRow, setSelectedRow] = useState()
    const [isColumnSelect, setIsColumnSelect] = useState(false)
    const location = useLocation()
    const dispatch = useDispatch()
    const [searchParams, setSearchParams] = useSearchParams();
    const [loading, setLoading] = useState(false)
    const selectedRows = useSelector(state => state?.MultiSelectSliceConditionally?.selectedRows?.selectedIds)
    const [confirmationState, setConfirmationState] = useState({ isOpen: false, rowData: '', multirow: '', user_names: [] });
    const [textAreaMsg, setTextAreaMsg] = useState('')
    const [emptyField, setEmptyField] = useState(false);
    const [dateField, setDateField] = useState(false);
    const searchApplied = useSelector((state) => state.deviceSearchData.prosearchApplied);

    const auth = useSelector(state => state?.auth)
    const deviceSearch = useSelector((state) => state.deviceSearchData);
    const { userType } = auth
    const initialState={
        "filter_start_date":'',
        "filter_end_date":'',
        'reading_type':[],
        'status':[],
    }
    const [filterValues, setFilterValues] = useState(initialState);
    const [multiDelete, setMultiDelete] = useState(false);
    const [isChangeStatusOPen, setIsChangeStatusOpen] = useState(false)
    const [changeStatusModel, setChangeStatusModel] = useState(false)
    const [selectedStatus, setSelectedStatus] = useState('')
  
    let queryParamsPassed={searchparams:searchParams?.toString(),isPatient:isPatient,patientId:patient_id}
    const { data, isFetching, isLoading, status } = useGetDeviceListQuery(queryParamsPassed, { skip: skip || location.search === '' })

    // const { data, isFetching, isLoading, status,} = useGetDeviceListQuery(searchParams?.toString(), { skip: skip || location.search === '',refetchOnMountOrArgChange: true });

    /**
     * The function `handleSearchParams` updates the search parameters by setting the value of a
     * specific key and value, and then updating the search parameters state.
     */
    const handleSearchParams = (key, value) => {
        let params = Object.fromEntries(searchParams);
        // Only reset page_number to 1 for search-related changes, not for initialization
        if (key !== 'page_number' && (key === 'search' || key === 'limit')) {
            params.page_number = 1
        }
        if (key === 'search') { params[key] = value; }
        else params[key] = value
        if (params.search === '') delete params.search
        setSearchParams({ ...params })
    }


    useEffect(() => {
       
        if (location.search === '') {
            setSkip(true)
        }
        if (location.state !== null && location.state !== '' && !Array.isArray(location.state)) {
            let params = {};
            if (location?.state?.search !== '' && !isPatient) {
                params = {
                    'limit': location.state.limit,
                    'page_number': location.state.page_number,
                    'search': decodeURIComponent(location.state.search),
                    'search_mode': decodeURIComponent(location.state.search_mode)
                }
            } else if (!isPatient) {
                // Handle case when search is empty but other params exist
                params = {
                    'limit': location.state.limit,
                    'page_number': location.state.page_number,
                }
            }
            if(isPatient){
                params = {
                    'limit': location.state.limit,
                    'page_number': location.state.page_number,
                }
            }
            isPatient ? params['tab'] = 'device_details' : ''
            setSearchParams({ ...params })
        }
        else {
            if (!searchParams.get('limit')) {
                handleSearchParams('limit', '15')
            }
            if (!searchParams.get('page_number')) {
                handleSearchParams('page_number', '1')
            }
         
        }
        setSuggestions(!searchParams.get('search') ? '' : decodeURIComponent(searchParams.get('search'))|| '')
    }, [location]);

    useEffect(() => {
        if (isPatient===undefined?searchParams.size >= 2:searchParams.size>=3) {
            setSkip(false)
        }
        else {
            setSkip(true)
        }
    }, [searchParams])

    useEffect(()=>{
        return(()=>{
            isPatient===undefined&&dispatch(resetArrays())
        })
    },[])

    function handleNoOfRowsClick(number) {
        // setLoading(true);
        let params = Object.fromEntries(searchParams);
        params.page_number = 1;
        params["limit"] = number;
        setSearchParams({ ...params });
    }
    const handleOnClickPageNumber = (pageNum) => {
        // setLoading(true);
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum })
        // dispatch(addToTopCheckbox([pageNum.selected+1,searchParams.get("limit")]))
    }

    const handleOnSubmit = (e) => {
        e.preventDefault();

        let searchString = '';
    
        // Utility function to format the search value as __NULL__ if only hyphens are present
        const formatSearchValue = (value) => {
            const trimmedValue = value.trim();
            return trimmedValue === '-' ? '__NULL__' : trimmedValue;
        };
    
        // Check if all date fields contain only hyphens in the correct format
        const isCompleteHyphenDate = (day, month, year) =>
            day === '--' && month === '--' && year === '----';
    
        // Check if any date field is partially filled
        const isPartialDateFilled = (day, month, year) =>
            (day && (!month || !year)) || (month && (!day || !year)) || (year && (!day || !month));
    
        /// Helper function to add date fields to the search string if valid
        const addDateToSearchString = (day, month, year, key, inverse = false) => {
            if (isPartialDateFilled(day, month, year)) {
                // If any date fields are partially filled, show an error and stop execution
                setDateField(true);
                return false; // Stop processing if partially filled
            } else if (isCompleteHyphenDate(day, month, year)) {
                // If all fields are fully filled with hyphens, set as __NULL__
                const prefix = inverse ? 'ne:' : '';
                searchString += `${key}=${prefix}__NULL__;`;
                return true;
            } else if (day && month && year) {
                // If all date fields are completely filled, format the date
                const formattedDate = `${year}-${month}-${day}T00:00:00Z`; // Ensure proper ISO format
                const prefix = inverse ? 'ne:' : '';
        
                // Convert to the appropriate format based on the key
                if (key === 'initial_reading_timestamp' || key === 'assigned_at') {
                    // Convert to epoch for initial_reading_timestamp and assigned_at
                    const date = new Date(formattedDate);
                    
                    if (isNaN(date.getTime())) {
                        console.error("Invalid date format:", formattedDate);
                        setDateField(true); // Show error if the date is invalid
                        return false;
                    }
        
                    const epoch = Math.floor(date.getTime() / 1000); // Convert to seconds
                    searchString += `${key}=${prefix}${encodeURIComponent(epoch)};`;
                } else if (key === 'purchase_date_str' || key === 'service_activation_date_str') {
                    // Convert to MM/DD/YYYY for purchase_date_str and service_activation_date_str
                    const dateStr = `${month}/${day}/${year}`;
                    searchString += `${key}=${prefix}${encodeURIComponent(dateStr)};`;
                }
                return true;
            }
            return true;
        };        

    
        // Destructure date parts and other fields from deviceSearch
        const {
            initial_reading_day,
            initial_reading_month,
            initial_reading_year,
            assigned_day,
            assigned_month,
            assigned_year,
            purchase_date_day,
            purchase_date_month,
            purchase_date_year,
            service_activation_date_day,
            service_activation_date_month,
            service_activation_date_year,
        } = deviceSearch || {};
    
        // Check dates and update search string only if processing continues
        if (!addDateToSearchString(
            initial_reading_day,
            initial_reading_month,
            initial_reading_year,
            'initial_reading_timestamp',
            deviceSearch?.initial_reading_inverse
        )) return;
    
        if (!addDateToSearchString(
            assigned_day,
            assigned_month,
            assigned_year,
            'assigned_at',
            deviceSearch?.assigned_at_inverse
        )) return;
    
        if (!addDateToSearchString(
            purchase_date_day,
            purchase_date_month,
            purchase_date_year,
            'purchase_date_str',
            deviceSearch?.purchase_date_inverse
        )) return;
    
        if (!addDateToSearchString(
            service_activation_date_day,
            service_activation_date_month,
            service_activation_date_year,
            'service_activation_date_str',
            deviceSearch?.service_activation_date_inverse
        )) return;
    
        // Add other fields to search string
        if (deviceSearch?.device_id && deviceSearch?.device_id.trim()!=='') {
            const deviceIdPrefix = deviceSearch.device_id_inverse ? 'ne:' : '';
            const formattedDeviceId = formatSearchValue(deviceSearch.device_id);
            searchString += `device_id=${deviceIdPrefix}${encodeURIComponent(formattedDeviceId)};`;
        }
    
        if (deviceSearch?.manufacturer_name && deviceSearch?.manufacturer_name.trim()!=='') {
            const manufacturerPrefix = deviceSearch.manufacturer_name_inverse ? 'ne:' : '';
            const formattedManufacturer = formatSearchValue(deviceSearch.manufacturer_name);
            searchString += `manufacturer_name=${manufacturerPrefix}${encodeURIComponent(formattedManufacturer)};`;
        }
    
        if (deviceSearch?.model && deviceSearch?.model.trim()!=='') {
            const modelPrefix = deviceSearch.model_inverse ? 'ne:' : '';
            const formattedModel = formatSearchValue(deviceSearch.model);
            searchString += `model=${modelPrefix}${encodeURIComponent(formattedModel)};`;
        }
    
        if (deviceSearch?.serial_number && deviceSearch?.serial_number.trim()!=='') {
            const serialNumberPrefix = deviceSearch.serial_number_inverse ? 'ne:' : '';
            const formattedSerialNumber = formatSearchValue(deviceSearch.serial_number);
            searchString += `serial_number=${serialNumberPrefix}${encodeURIComponent(formattedSerialNumber)};`;
        }
    
        if (deviceSearch?.patient_id && deviceSearch?.patient_id.trim()!=='') {
            const patientIdPrefix = deviceSearch.patient_id_inverse ? 'ne:' : '';
            const formattedPatientId = formatSearchValue(deviceSearch.patient_id);
            searchString += `patient_id=${patientIdPrefix}${encodeURIComponent(formattedPatientId)};`;
        }
    
        if (deviceSearch?.service_provider && deviceSearch?.service_provider.trim()!=='') {
            const serviceProviderPrefix = deviceSearch.service_provider_inverse ? 'ne:' : '';
            const formattedServiceProvider = formatSearchValue(deviceSearch.service_provider);
            searchString += `service_provider=${serviceProviderPrefix}${encodeURIComponent(formattedServiceProvider)};`;
        }
    
        if (deviceSearch?.service_period && deviceSearch?.service_period.trim()!=='') {
            const servicePeriodPrefix = deviceSearch.service_period_inverse ? 'ne:' : '';
            const formattedServicePeriod = formatSearchValue(deviceSearch.service_period);
            searchString += `service_period=${servicePeriodPrefix}${encodeURIComponent(formattedServicePeriod)};`;
        }
    
        if (deviceSearch?.warranty_period && deviceSearch?.warranty_period.trim()!=='') {
            const warrantyPeriodPrefix = deviceSearch.warranty_period_inverse ? 'ne:' : '';
            const formattedWarrantyPeriod = formatSearchValue(deviceSearch.warranty_period);
            searchString += `warranty_period=${warrantyPeriodPrefix}${encodeURIComponent(formattedWarrantyPeriod)};`;
        }
    
        if (deviceSearch?.description && deviceSearch?.description.trim()!=='') {
            const descriptionPrefix = deviceSearch.description_inverse ? 'ne:' : '';
            const formattedDescription = formatSearchValue(deviceSearch.description);
            searchString += `description=${descriptionPrefix}${encodeURIComponent(formattedDescription)};`;
        }
    
        // Remove trailing ';' if present
        searchString = searchString.endsWith(';') ? searchString.slice(0, -1) : searchString;
    
        // Merge all search parameters into a single object
        const currentParams = Object.fromEntries(searchParams);
        const newParams = {
            ...currentParams,
            search: searchString || '',
            search_mode: deviceSearch.match === false ? 'and' : 'or',
            page_number: 1,
            sort: currentParams.sort || 'created_at+desc',
            limit: currentParams.limit || '15',
        };
    
        if (!newParams.search) delete newParams.search;
    
        setSearchParams(newParams);
        dispatch(setSearchApplied());
    };
        

    useEffect(() => {
        // If search was not applied, reset the search fields on page load
        if (!searchApplied) {
            dispatch(resetDeviceSearch());
        }
    }, [dispatch, searchApplied]);


    useEffect(() => {
        if (data !== undefined) {
            dispatch(limitReducer([data, searchParams.get("limit"), searchParams.get("page_number")]))
        }
    }, [data?.data]);

    const handleChange = (val) => {
        handleSearchParams('search', val)

    };

    const optimizedFn = useCallback(
        Debounce((value) => handleChange(value)),
        [searchParams]
    );

    const handleApplyFilter = (type) => {
        let params = { ...Object.fromEntries(searchParams) };
        const start_date = moment(filterValues.filter_start_date).format('YYYY-MM-DD');
        const end_date = moment(filterValues.filter_end_date).format('YYYY-MM-DD');
    
        const filterValuesToDispatch = {};
    
        if (filterValues.filter_start_date) {
            filterValuesToDispatch["filter_start_date"] = filterValues.filter_start_date;
        }
    
        if (filterValues.filter_end_date) {
            filterValuesToDispatch["filter_end_date"] = filterValues.filter_end_date;
        }
    
        if (filterValues.status.length > 0) {
            filterValuesToDispatch["status"] = filterValues.status.join(',');
        }
    
        if (filterValues.search) {
            filterValuesToDispatch['search'] = filterValues.search;
        }
    
        if (Array.isArray(filterValues.reading_type) && filterValues.reading_type.length > 0) {
            filterValuesToDispatch["reading_type"] = filterValues.reading_type.join(',');
        } else if (filterValues.reading_type !== "") {
            filterValuesToDispatch["reading_type"] = filterValues.reading_type;
        }
    
        if (type) {
            const updatedParams = {
                filter: "true",
                page_number: 1,
                limit,
                ...(filterValues.filter_start_date && { start_date: convertDatesToEpochUTC(start_date, Intl.DateTimeFormat().resolvedOptions().timeZone, true) }),
                ...(filterValues.filter_end_date && { end_date: convertDatesToEpochUTC(end_date, Intl.DateTimeFormat().resolvedOptions().timeZone, false) }),
                ...(filterValues.status.length > 0 && { status: filterValues.status.join(',') }),
                ...(filterValues.reading_type.length > 0 && { reading_type: filterValues.reading_type.join(',') }),
            };
            if (searchParams.get('search')) {
                updatedParams.search = searchParams.get('search');
            }
            if (searchParams.get('tab')) {
                updatedParams.tab = searchParams.get('tab');
            }
            setSearchParams(updatedParams);
    
        } else {
            // Preserve the search parameter and remove only the filter-related parameters
            delete params['status'];
            delete params['reading_type'];
            delete params['start_date'];
            delete params['end_date'];
            setSearchParams(params);
        }
    
        // Dispatch filter values regardless of the 'type'
        dispatch(handleAddFilterValues(filterValuesToDispatch));
    };
    
    
    


    function handleCheckBox(key, option) {
        setIsAnyFieldFilled!==undefined&&setIsAnyFieldFilled(true)
        setFilterValues((prev) => {
            const updatedFilterValues = { ...prev };
            // If the key already exists, toggle the option in the array
            updatedFilterValues[key] = updatedFilterValues[key] ? (
                updatedFilterValues[key].includes(option)
                    ? updatedFilterValues[key].filter(item => item !== option)
                    : [...updatedFilterValues[key], option]
            ) : [option];
            return updatedFilterValues;
        });
    }

    /**
     * The function sets the confirmation state to an empty object when a confirmation click event
     * occurs.
     */
    const handleConformationClick = () => {
        setEmptyField(false)
        setTextAreaMsg("")
        setConfirmationState({});
    }
    // delete function
    const handleDelete = async (id) => {
        setLoading(true);
        let body = {
            device_id: [id]
        };
        const res = await deleteDevice(body);
        if (res?.error?.data?.message) {
            setToastErrorMessage(res?.error?.data?.message);
            setLoading(false);
            setEmptyField(false)
            setTextAreaMsg("")
            setConfirmationState({})
        } else {
            setSearchParams(Object.fromEntries(searchParams));
            setToastmessage('Device deleted successfully');
            setLoading(false);
            handleConformationClick();
        }
    };
    

    const totalPageNumber=Math.ceil(parseInt(data?.total_count) / parseInt(limit))

    // handle multiple delte
    const handleMultiRowDelete = async () => {
        if (textAreaMsg.trim() === '') {
            setToastErrorMessage('Please fill in the mandatory field');
            setEmptyField(true);
            return;
        }
        setLoading(true);
        setMultiDelete(true);
        const deviceIds = selectedRows.map(item => item.id);
        
        let body = {
            device_id: deviceIds,
        };
    
        const res = await deleteDevice(body);
    
        if (res?.error?.data?.message) {
            setToastErrorMessage(res?.error?.data?.message);
            setIsChangeStatusOpen(false);
            setLoading(false);
        } else {
            // Increment the page_number by 1 if the devices were on the last page
            const currentPageNumber = parseInt(searchParams.get('page_number')) || 1;
            const updatedPageNumber = (currentPageNumber > 1) ? currentPageNumber - 1 : 1;
            // Update the page_number in the URLSearchParams
            searchParams.set('page_number', updatedPageNumber);
            setSearchParams(Object.fromEntries(searchParams));
            setToastmessage('Devices deleted successfully');
            setLoading(false);
            setMultiDelete(false);
            setIsChangeStatusOpen(false);
            dispatch(resetArrays());
            setTextAreaMsg('');
        }
    };
    
    const handleDeleteModelClose = () => {
        setTextAreaMsg("")
        setConfirmationState({});
        setMultiDelete(false);
    }

    const handleStatusChangeModal = (value) => {
        setSelectedStatus(value);
        setChangeStatusModel(true) 
    }

    const handleStatusCloseChangeModal = (value) => {
        setSelectedStatus('');
        setTextAreaMsg("")
        setConfirmationState({});
        setChangeStatusModel(false) 
    }

    const handleStatusChange = async() => {    
        if((textAreaMsg.trim()=== '')){ 
            setToastErrorMessage('Please fill in the mandatory field')
            setEmptyField(true)
            return;
        }
        const filteredRows = selectedRows.filter(item => item.status !== selectedStatus);
        let body = {
            "device_id": filteredRows.map(item => item.id),
            "status": selectedStatus,
            "note": textAreaMsg,
        };
        setLoading(true)
        const response = await statusChange({body})
        if(response?.error) {
            setToastErrorMessage(response.error.data.message)
            setChangeStatusModel(false)
            setLoading(false)
        } else{
            if(selectedStatus === 'active'){
                setToastmessage('Devices activated successfully')
            } else{
                setToastmessage(`Devices status changed to ${transformStatusWord(selectedStatus)} successfully`);
            }
            setChangeStatusModel(false)
            setLoading(false)
        }
        setTextAreaMsg('');
        dispatch(resetArrays())
    }

    function transformWords(item) {
        // Add your transformation logic here
        if (item === 'active') {
            return 'Activate';
        } else if (item === 'out-of-service') {
            return 'Out of Service';
        } else if (item === 'retired'){
            return 'Retire';
        }    
        return item;
    }
      
    function transformStatusWord(item){
        if (item === 'active') {
            return 'activate';
        } else if (item === 'out-of-service') {
            return 'out of service';
        } else if (item === 'retired'){
            return 'retired';
        }    
        return item;

    }
    const handleClearFilter = () => {
        let params = Object.fromEntries(searchParams);
        delete params.reading_type
        delete params.status
        delete params.end_date
        delete params.start_date
        setSearchParams({ ...params })
    }
    const deviceIds = selectedRows.map(item => item?.id);
    
    return (
        <>
            <div className={` ${isPatient===undefined?'pt-[95px] px-[30px] bg-[#F9F3F5]':''} h-full w-full overflow-x-hidden`}>
                {isPatient===undefined&&<TopHeader title={"Manage Devices"} />}
                <div className={`bg-white rounded-lg ${isPatient===undefined?'py-3 h-customh3':''}  relative`}>
                    <div className={`${isPatient===undefined?'px-6':''}`}>
                        <ManageDeviceTopBar
                            title={`${isPatient===undefined?'List of Devices':'Choose devices to associate with the patient'}`}
                            path={'/manage-devices/add-device'}
                            AddButton={true}
                            SearchInput={((data?.data?.length===0 &&searchParams.get("search")===null) ||data===undefined) ? false : true}
                            SearchPlaceholder={'Search for ID,Device Name'}
                            buttonName={"Add Device"}
                            menuBar={(data !== undefined && data?.data?.length>0&&selectedRows?.length > 0) ? true : false}
                            suggestions={suggestions}
                            setSuggestions={setSuggestions}
                            setConfirmationState={setConfirmationState}
                            optimizedFn={optimizedFn}
                            data={data}
                            searchDevice={true}
                            exportCols={['ID', 'Status', 'Reading Type', 'Manufacturer','Model', 'Serial Number', 'Patient ID','Assigned','Purchase Date','Service Provider','Service Period','Service Activation','Warranty Period','Initial Reading','Description','Created']}
                            isColumnSelect={isColumnSelect}
                            setIsColumnSelect={setIsColumnSelect}
                            exportDevice={exportDevice}
                            filterValues={filterValues}
                            setFilterValues={setFilterValues}
                            handleApplyFilter={handleApplyFilter}
                            handleMultiRowDelete={handleMultiRowDelete}
                            setMultiDelete={setMultiDelete}
                            setIsChangeStatusOpen={setIsChangeStatusOpen}
                            isChangeStatusOPen={isChangeStatusOPen}
                            totalPageNumber={Math.ceil(parseInt(data?.total_count) / parseInt(limit))}
                            handleCheckBox={handleCheckBox}
                            ApplyFilter={(data===undefined)?false:true}
                            selectedRows={selectedRows}
                            handleStatusChangeModal={handleStatusChangeModal}
                            selectedStatus={selectedStatus}
                            initialState={initialState}
                            handleClearFilter={handleClearFilter}
                            isPatient={isPatient}
                            setIsAnyFieldFilled={setIsAnyFieldFilled}

                        /> 
                    </div>
                    {((isFetching && status !== "fulfilled" && status !== "rejected") || (isLoading) || (data === undefined && status !== "fulfilled" && status !== "rejected"))  ? 
                        <CustomOverLay Active text="Loading Device list..." classKey={`absolute top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center  ${isSideBar ? (isPatient!==undefined?'opened_sidebar_overlay_patient':'opened_sidebar_overlay') : isPatient!==undefined?'overlay_device_patient':'overlay-list'}`} /> :(data !== undefined && data?.data?.length > 0)  ? <>
                            <div className={`${isPatient===undefined?'px-6':''}`}>
                                <ManageDeviceTable
                                    pageNumber={Number(searchParams.get('page_number')) || 1}
                                    List={data}
                                    isPatient={isPatient}
                                    handleSearchParams={handleSearchParams}
                                    setConfirmationState={setConfirmationState}
                                    setTextAreaMsg={setTextAreaMsg}
                                    setSelectedRow={setSelectedRow}
                                    handleDelete={handleDelete}
                                    loading={loading}
                                    setLoading={setLoading}
                                    setIsAnyFieldFilled={setIsAnyFieldFilled}
                                />
                            </div>
                            {data?.total_count >= 15 && <div className="w-full px-2.5 py-1 flex items-center justify-between bg-[#F4F7FC] rounded-b-lg">
                                <p className="text-sm font-semibold text-[#687182]">Total Number of Records:{Math.ceil(parseInt(data?.total_count))}</p>
                                <div className="flex items-center">
                                    <Limit
                                        limit={limit}
                                        setLimit={setLimit}
                                        handleNoOfRowsClick={handleNoOfRowsClick}
                                        isColumnSelect={isColumnSelect}
                                    />

                                    <Pagination
                                        TotalCount={parseInt(data?.total_count)}
                                        totalPageNumber={Math.ceil(parseInt(data?.total_count) / parseInt(searchParams?.get("limit")))}
                                        handleOnClickPageNumber={handleOnClickPageNumber}
                                        limit={parseInt(limit)}
                                    />
                                </div>
                            </div>}
                        </> : <>
                            {/* empty screen */}
                            {(data?.total_count===0 &&suggestions?.trim()!=="")||(data?.success_status==="false")  ?
                                <SearchEmptyScreen text={"No exact matches found. Please try a different search"} isPatient={isPatient} />
                                :
                                ((searchParams.get("status")!==null||searchParams.get("reading_type")!==null||searchParams.get("start_date")!==null||searchParams.get("end_date")!==null)&&data?.total_count===0)?<SearchEmptyScreen
                                    text={"That filter combination has no result. Please try different criteria"} setSkip={setSkip} isPatient={isPatient}/>
                               
                                    :(data?.total_count===0 && !searchParams.get("search")&&(!searchParams.get("filter")))?<Emptyscreen  isPatientDeviceTemplate={isPatient} title={"Manage Devices"} FirstPTag={"No Devices added yet."}SecondePTag={"Start managing by clicking 'Add Device'"} />:
                                        ((status==="rejected"||(data?.total_count!==0&&data?.data?.length===0))&&<SearchEmptyScreen text={"No data found"} isPatient={isPatient} />)
                            }

                        </>}
                </div>
                {confirmationState.isOpen &&
                    <AnimatedModel
                        Children={
                            <ConfirmationPrompt
                                handleOnCLickActivate={handleDelete}
                                handleClose={handleConformationClick}
                                tittle= {'Delete'}
                                message = {`Are you sure you want to delete this device?`}
                                buttonName = {"Yes"}
                                loadingActivation={loading}
                                disabled={loading}
                                CancelButton = {"No"}
                            />
                        }
                    />
                }
                {multiDelete &&
                    <AnimatedModel
                        Children={
                            <ConfirmationPrompt
                                emptyField={emptyField}
                                setEmptyField={setEmptyField}
                                setTextAreaMsg={setTextAreaMsg}
                                textAreaMsg={textAreaMsg}
                                handleOnCLickActivate={handleMultiRowDelete}
                                handleClose={handleDeleteModelClose}
                                tittle={'Delete'}
                                message={`Are you sure you want to delete the selected devices?`}
                                userList={ selectedRows.map(item => item.id)}
                                buttonName={"Yes"}
                                loadingActivation={loading}
                                disabled={loading}
                                CancelButton={"No"}
                            />
                        }
                    />
                }
                {changeStatusModel && 
                    <AnimatedModel 
                        Children={
                            <ConfirmationPrompt
                                emptyField={emptyField}
                                setEmptyField={setEmptyField}
                                setTextAreaMsg={setTextAreaMsg}
                                textAreaMsg={textAreaMsg}
                                handleOnCLickActivate={handleStatusChange}
                                handleClose={handleStatusCloseChangeModal}
                                tittle= {transformWords(selectedStatus)}
                                message = {selectedStatus=== "activate" ? `Are you sure you want activate this device?` :`Are you sure you want to change the status of the following device to ${transformStatusWord(selectedStatus)}?`}
                                textMessage = {confirmationState.rowData!==""?confirmationState?.rowData?.status === 'inactive' ? true : false:confirmationState.multirow==="active"?true:false}
                                buttonName = {'Yes'}
                                userList={selectedRows.filter(item => item.status !== selectedStatus).map(item =>item.id)}
                                loadingActivation={loading}
                                CancelButton={'No'}
                                disabled={loading}
                            />
                        }
                    /> 
                }
            </div>
            {isAdvancedSearchOpen&&searchParams?.get('limit')&&!searchParams?.get('target_user_name')&&!searchParams?.get('tab') &&
                <DeviceAdvanceSearch
                    handleOnSubmit={handleOnSubmit}
                    emptyField={dateField}
                    setEmptyField={setDateField}
                />
            }
        </>

    )
}
